import React, { useRef } from 'react';
import Messages from 'i18n/messages/home';
import { CustomNotification } from 'common/components';

import { UploadOutlined } from '@ant-design/icons';
import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';
import { useIntl } from 'react-intl';

import * as api from 'config/axios';
import * as endpoints from 'services/digitalAsset/endpoints';

import { useDispatchReloadPage } from 'hooks/useReloadPage';
import useUpdateIXONEShield from 'common/components/product-add/useUpdateIXONEShield';
import { useCheckShowIxOneWarning } from 'common/components/product-add/useCheckShowIxOneWarning';

import { notification } from 'antd';
import {
  IXONECertificationWrapper,
  TYPE_VIEW,
} from 'common/components/product-add/IXONECertificationWrapper';

import { ProductIxoneCertification } from './ProductIxoneCertification';
import { readDataFromXlsxFile } from 'utils/common/readDataFromXlsxFile';

const UpdateMultipleAsset = (props) => {
  const { disabled } = props;
  const intl = useIntl();
  const reloadPage = useDispatchReloadPage();

  const { handleUpdateIXONEShield } = useUpdateIXONEShield();
  const { showConfirmIxOneModal } = useCheckShowIxOneWarning();

  const fileRef = useRef();

  const renderErrorListMsg = (stringError, title) => {
    return (
      <div>
        <span style={{ fontSize: '15px', color: 'rgba(0, 0, 0, 0.85)' }}>
          {title}
        </span>
        {stringError?.length > 0 &&
          stringError.map((val, index) => <div key={index}>{val}</div>)}
        {stringError?.length === 0 && (
          <span>{Messages.uploadAssetsTemplateMsgFailed}</span>
        )}
      </div>
    );
  };
  const handleUpdateMultipleAsset = async (ixoneIgnore, fieldList) => {
    const payload = {
      file: fileRef.current,
    };

    try {
      const response = await api.sendUpload({
        api: endpoints.UPDATE_MULTIPLE_ASSET,
        payload,
      });

      if (response?.data?.isSuccess) {
        CustomNotification.success(
          intl.formatMessage(Messages.uploadAssetsTemplateMsgSuccess)
        );

        const productIds = fieldList?.map((item) => item?.productId);
        await handleUpdateIXONEShield(ixoneIgnore, productIds);

        fileRef.current = null;
        reloadPage();
      } else {
        if (response?.data?.data === null) {
          CustomNotification.error(response.data?.message);
          return;
        }
        let stringError = [];
        let arrayError =
          response?.data?.data?.errorMessages &&
          response?.data?.data?.errorMessages?.length > 0 &&
          response?.data?.data?.errorMessages;
        arrayError &&
          arrayError.length > 0 &&
          arrayError.forEach((val) => {
            stringError.push(
              `Row: ${val?.rowIndex} - Column Name: ${val?.columnName} - ${val?.message}`
            );
          });
        notification.error({
          description: renderErrorListMsg(stringError, response?.data?.message),
        });
      }
    } catch (error) {
      CustomNotification.error(error || Messages.uploadAssetsTemplateMsgFailed);
    }
  };

  const checkShowConfirmMessage = async (assetData, handleConfirmIXONE) => {
    const deletedAsset = assetData
      ?.filter((item) => item?.Status?.toLowerCase() === 'deleted')
      ?.map((item) => item?.Id);

    showConfirmIxOneModal({
      showModal: true,
      handleConfirmIXONE,
      assetIds: deletedAsset,
    });
  };

  const onClick = async (handleConfirmIXONE) => {
    const $input = document.createElement('input');
    $input.setAttribute('type', 'file');

    const handleSelectFile = async (event) => {
      const file = event.target.files[0];

      if (!file) return;

      if (
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        try {
          fileRef.current = file;

          const assetData = await readDataFromXlsxFile(file);
          if (!assetData?.length) {
            CustomNotification.error('File is invalid or contains no data.');
            return;
          }

          checkShowConfirmMessage(assetData, handleConfirmIXONE);
        } catch (error) {
          console.error('Error while processing Excel file:', error);
          CustomNotification.error('Failed to read or process Excel file.');
        }
      } else {
        CustomNotification.error('Only accept .xlsx file');
      }
    };

    $input.onchange = handleSelectFile;
    $input.click();
  };

  return (
    <IXONECertificationWrapper
      type={TYPE_VIEW.IMAGE_ASSET}
      Component={ProductIxoneCertification}
      onConfirm={(ixoneIgnore, fieldList) => {
        handleUpdateMultipleAsset(ixoneIgnore, fieldList);
      }}
    >
      {(handleConfirmIXONE) => (
        <ButtonSmallIcon
          className='button-item-dropdown'
          icon={<UploadOutlined />}
          label={Messages.uploadAssetsTemplate}
          onClick={() => onClick(handleConfirmIXONE)}
          disabled={disabled}
        />
      )}
    </IXONECertificationWrapper>
  );
};

UpdateMultipleAsset.propTypes = {};

export default UpdateMultipleAsset;
